import { IChapterBilling } from '../models/Chapter/IChapterBilling';
import { IHrInterests } from '../models/Profile/IHrInterests';
import { IProfile } from '../models/Profile/IProfile';
import { IProfileContainer } from '../models/Profile/IProfileContainer';
import { IProfileEdit } from '../models/Profile/IProfileEdit';
import { IProfilePhoto } from '../models/Profile/IProfilePhoto';

function profileServiceMock() {
  function getProfile(id: string): any {
    const profileEdit: IProfileEdit = {
      prefixes: [
        { value: 'Dr.', label: 'Dr.' },
        { value: 'Miss', label: 'Miss' },
        { value: 'Mr.', label: 'Mr.' },
        { value: 'Mrs.', label: 'Mrs.' },
        { value: 'Ms.', label: 'Ms.' },
        { value: 'Prof.', label: 'Prof.' },
        { value: 'Rev.', label: 'Rev.' },
        { value: 'Sr.', label: 'Sr.' },
        { value: 'The Hon.', label: 'The Hon.' },
      ],
      suffixes: [
        { value: 'II', label: 'II' },
        { value: 'III', label: 'III' },
        { value: 'IV', label: 'IV' },
        { value: 'Jr.', label: 'Jr.' },
        { value: 'Sr.', label: 'Sr.' },
      ],

      credentials: [
        { value: '1', label: 'AAAPM' },
        { value: '2', label: 'AAE' },
        { value: '3', label: 'ABC' },
        { value: '4', label: 'ABD' },
        { value: '5', label: 'AFAHRI' },
        { value: '6', label: 'AHRI' },
        { value: '7', label: 'AIRS' },
        { value: '8', label: 'APR' },
        { value: '9', label: 'ARM' },
        { value: '10', label: 'ASTD' },
        { value: '11', label: 'BA' },
        { value: '12', label: 'BBA' },
        { value: '13', label: 'BCC' },
        { value: '14', label: 'BS' },
        { value: '15', label: 'BSBA' },
        { value: '16', label: 'BSC' },
        { value: '17', label: 'BSN' },
        { value: '18', label: 'CA' },
        { value: '19', label: 'CAE' },
        { value: '20', label: 'CAM' },
        { value: '21', label: 'CAP' },
        { value: '22', label: 'CAPM' },
        { value: '23', label: 'CBCP' },
        { value: '24', label: 'CBM' },
        { value: '25', label: 'CBP' },
        { value: '26', label: 'CCC' },
        { value: '27', label: 'CCDP' },
        { value: '28', label: 'CCDP/AP' },
        { value: '29', label: 'CCM' },
        { value: '30', label: 'CCP' },
        { value: '31', label: 'CCT' },
        { value: '32', label: 'CDE' },
        { value: '33', label: 'CDMS' },
        { value: '34', label: 'CDR' },
        { value: '35', label: 'CDR AIRS' },
        { value: '36', label: 'CDS' },
        { value: '37', label: 'CEAP' },
        { value: '38', label: 'CEBS' },
        { value: '39', label: 'CEO' },
        { value: '40', label: 'CEP' },
        { value: '41', label: 'CFA' },
        { value: '42', label: 'CFEd' },
        { value: '43', label: 'CFFA' },
        { value: '44', label: 'CFM' },
        { value: '45', label: 'CFP' },
        { value: '46', label: 'CFP(R)' },
        { value: '47', label: 'CGFM' },
        { value: '48', label: 'CGMA' },
        { value: '49', label: 'CHCR' },
        { value: '50', label: 'CHE' },
        { value: '51', label: 'CHFC' },
        { value: '52', label: 'CHRE' },
        { value: '53', label: 'CHRP' },
        { value: '54', label: 'CHRS' },
        { value: '55', label: 'CIPD' },
        { value: '56', label: 'CIPMN' },
        { value: '57', label: 'CIR' },
        { value: '58', label: 'CLA' },
        { value: '59', label: 'CLM' },
        { value: '60', label: 'CLRS' },
        { value: '61', label: 'CLSSS' },
        { value: '62', label: 'CLU' },
        { value: '63', label: 'CM' },
        { value: '64', label: 'CMA' },
        { value: '65', label: 'CMAHRI' },
        { value: '66', label: 'CMBA' },
        { value: '67', label: 'CMC' },
        { value: '68', label: 'CMCA' },
        { value: '69', label: 'CMF' },
        { value: '70', label: 'CMS' },
        { value: '71', label: 'COHN' },
        { value: '72', label: 'COHN-S' },
        { value: '73', label: 'COP' },
        { value: '74', label: 'CPA' },
        { value: '75', label: 'CPB' },
        { value: '76', label: 'CPC' },
        { value: '77', label: 'CPCU' },
        { value: '78', label: 'CPDM' },
        { value: '79', label: 'CPHR' },
        { value: '80', label: 'CPhT' },
        { value: '81', label: 'CPIM' },
        { value: '82', label: 'CPLP' },
        { value: '83', label: 'CPM' },
        { value: '84', label: 'CPP' },
        { value: '85', label: 'CPRW' },
        { value: '86', label: 'CPS' },
        { value: '87', label: 'CRC' },
        { value: '88', label: 'CRITQM' },
        { value: '89', label: 'CRP' },
        { value: '90', label: 'CRSP' },
        { value: '91', label: 'CSA' },
        { value: '92', label: 'CSC' },
        { value: '93', label: 'CSP' },
        { value: '94', label: 'CSSBB' },
        { value: '95', label: 'CSSGB' },
        { value: '96', label: 'CSW' },
        { value: '97', label: 'CTS' },
        { value: '98', label: 'CVA' },
        { value: '99', label: 'CWCP' },
        { value: '100', label: 'DBA' },
        { value: '101', label: 'DC' },
        { value: '102', label: 'DDI' },
        { value: '103', label: 'DDS' },
        { value: '104', label: 'DM' },
        { value: '105', label: 'DN' },
        { value: '106', label: 'DPA' },
        { value: '107', label: 'DSW' },
        { value: '108', label: 'Ed.D' },
        { value: '109', label: 'Ed.E' },
        { value: '110', label: 'Ed.M' },
        { value: '111', label: 'Ed.S' },
        { value: '112', label: 'Esq.' },
        { value: '113', label: 'FACHE' },
        { value: '114', label: 'FCIPD' },
        { value: '115', label: 'FLMI' },
        { value: '116', label: 'FPC' },
        { value: '117', label: 'FSA' },
        { value: '118', label: 'GBA' },
        { value: '119', label: 'GIPD' },
        { value: '120', label: 'GMS' },
        { value: '121', label: 'GRP' },
        { value: '122', label: 'HCS' },
        { value: '123', label: 'HIA' },
        { value: '124', label: 'HRIP' },
        { value: '125', label: 'HRM' },
        { value: '126', label: 'HRMS' },
        { value: '127', label: 'IPD' },
        { value: '128', label: 'IPD UK' },
        { value: '129', label: 'IPM' },
        { value: '130', label: 'IPMA' },
        { value: '131', label: 'IPMA CP' },
        { value: '132', label: 'IPMA-CP' },
        { value: '133', label: 'IPMA-CS' },
        { value: '134', label: 'IPMA-HR' },
        { value: '135', label: 'IRMA CP' },
        { value: '136', label: 'ISCEBS' },
        { value: '137', label: 'JD' },
        { value: '138', label: 'LCSW' },
        { value: '139', label: 'LCSW-C' },
        { value: '140', label: 'LIC' },
        { value: '141', label: 'LLM' },
        { value: '142', label: 'LMHC' },
        { value: '143', label: 'LPC' },
        { value: '144', label: 'LPN' },
        { value: '145', label: 'LSW' },
        { value: '146', label: 'MA' },
        { value: '147', label: 'MAEd.' },
        { value: '148', label: 'MAIR' },
        { value: '149', label: 'MAOM' },
        { value: '150', label: 'MAS' },
        { value: '151', label: 'MBA' },
        { value: '152', label: 'MBA HRM' },
        { value: '153', label: 'MBOL' },
        { value: '154', label: 'MCIPD' },
        { value: '155', label: 'MCP' },
        { value: '156', label: 'MCSE' },
        { value: '157', label: 'MD' },
        { value: '158', label: 'MDPC' },
        { value: '159', label: 'MEd' },
        { value: '160', label: 'MHA' },
        { value: '161', label: 'MHR' },
        { value: '162', label: 'MHRIR' },
        { value: '163', label: 'MHRM' },
        { value: '164', label: 'MHROD' },
        { value: '165', label: 'MHSA' },
        { value: '166', label: 'MILR' },
        { value: '167', label: 'MIPD' },
        { value: '168', label: 'MLHR' },
        { value: '169', label: 'MLIR' },
        { value: '170', label: 'MLO' },
        { value: '171', label: 'MLRHR' },
        { value: '172', label: 'MMHR' },
        { value: '173', label: 'MNPL' },
        { value: '174', label: 'MPA' },
        { value: '175', label: 'MPAIR' },
        { value: '176', label: 'MPH' },
        { value: '177', label: 'MPhil' },
        { value: '178', label: 'MPM' },
        { value: '179', label: 'MPP' },
        { value: '180', label: 'MPS' },
        { value: '181', label: 'MS' },
        { value: '182', label: 'MS Ed.' },
        { value: '183', label: 'MS HRM' },
        { value: '184', label: 'MSA' },
        { value: '185', label: 'MSBA' },
        { value: '186', label: 'MSc' },
        { value: '187', label: 'MSCIS' },
        { value: '188', label: 'MSE' },
        { value: '189', label: 'MSEC' },
        { value: '190', label: 'MSEmpLaw' },
        { value: '191', label: 'MSHR' },
        { value: '192', label: 'MSIR' },
        { value: '193', label: 'MSM' },
        { value: '194', label: 'MSMOB' },
        { value: '195', label: 'MSOD' },
        { value: '196', label: 'MSS' },
        { value: '197', label: 'MSSL' },
        { value: '198', label: 'MSW' },
        { value: '199', label: 'NCC' },
        { value: '200', label: 'NHA' },
        { value: '201', label: 'OHP' },
        { value: '202', label: 'PA' },
        { value: '203', label: 'PCC' },
        { value: '204', label: 'PE' },
        { value: '205', label: 'Ph.D.' },
        { value: '206', label: 'PHR' },
        { value: '207', label: 'PHRBCOM' },
        { value: '208', label: 'PHRCPP' },
        { value: '209', label: 'PMP' },
        { value: '210', label: 'PRC' },
        { value: '211', label: 'PsyD' },
        { value: '212', label: 'REBC' },
        { value: '213', label: 'RLC' },
        { value: '214', label: 'RN' },
        { value: '215', label: 'RNC' },
        { value: '216', label: 'RODP' },
        { value: '217', label: 'RPA' },
        { value: '218', label: 'RRA' },
        { value: '219', label: 'SCRP' },
        { value: '220', label: 'SFSU' },
        { value: '221', label: 'SHRP' },
        { value: '222', label: 'Sr.' },
        { value: '223', label: 'SWP' },
        { value: '224', label: 'The Hon.' },
        { value: '225', label: 'TSC' },
        { value: '226', label: 'WLCP' },
      ],
      chapterStates: [
        { value: '', label: '- None -' },
        { value: '0', label: 'Alabama' },
        { value: '1', label: 'Alaska' },
        { value: '2', label: 'Arizona' },
        { value: '3', label: 'Arkansas' },
        { value: '4', label: 'California' },
        { value: '5', label: 'Colorado' },
        { value: '6', label: 'Connecticut' },
        { value: '7', label: 'Delaware' },
        { value: '9', label: 'Florida' },
        { value: '10', label: 'Georgia' },
        { value: '11', label: 'Hawaii' },
        { value: '12', label: 'Idaho' },
        { value: '13', label: 'Illinois' },
        { value: '14', label: 'Indiana' },
        { value: '15', label: 'Iowa' },
        { value: '16', label: 'Kansas' },
        { value: '17', label: 'Kentucky' },
        { value: '18', label: 'Louisiana' },
        { value: '19', label: 'Maine' },
        { value: '20', label: 'Maryland' },
        { value: '21', label: 'Massachusetts' },
        { value: '22', label: 'Michigan' },
        { value: '23', label: 'Minnesota' },
        { value: '24', label: 'Mississippi' },
        { value: '25', label: 'Missouri' },
        { value: '26', label: 'Montana' },
        { value: '27', label: 'Nebraska' },
        { value: '28', label: 'Nevada' },
        { value: '29', label: 'New Hampshire' },
        { value: '30', label: 'New Jersey' },
        { value: '31', label: 'New Mexico' },
        { value: '32', label: 'New York' },
        { value: '33', label: 'North Carolina' },
        { value: '34', label: 'North Dakota' },
        { value: '35', label: 'Ohio' },
        { value: '36', label: 'Oklahoma' },
        { value: '37', label: 'Oregon' },
        { value: '30037', label: 'Other State' },
        { value: '38', label: 'Pennsylvania' },
        { value: '39', label: 'Puerto Rico' },
        { value: '40', label: 'Rhode Island' },
        { value: '41', label: 'South Carolina' },
        { value: '42', label: 'South Dakota' },
        { value: '43', label: 'Tennessee' },
        { value: '44', label: 'Texas' },
        { value: '30038', label: 'US Territories-Guam' },
        { value: '45', label: 'Utah' },
        { value: '46', label: 'Vermont' },
        { value: '47', label: 'Virginia' },
        { value: '48', label: 'Washington' },
        { value: '49', label: 'West Virginia' },
        { value: '50', label: 'Wisconsin' },
        { value: '51', label: 'Wyoming' },
      ],
      chapterNames: null,
      dualBillingUrl:
        'https://store.shrm.org/dual-membership?src=mySHRM&state=[state_value]&chapter=[chapter_value]',
      yearsStartedHRLowerLimit: 1940,
      yearsStartedHRUpperLimit: 2022,
      educationLevels: [
        { value: '1', label: 'Not Identified' },
        { value: '2', label: "Associate's Degree" },
        { value: '3', label: "Bachelor's Degree" },
        { value: '4', label: "Bachelor's Degree, HR" },
        { value: '5', label: "Bachelor's Degree, non-HR" },
        { value: '6', label: 'College Beyond Bachelor' },
        { value: '7', label: 'Doctorate' },
        { value: '8', label: 'High School / GED' },
        { value: '9', label: 'JD' },
        { value: '10', label: "Master's Degree" },
        { value: '11', label: "Master's Degree, HR" },
        { value: '12', label: "Master's Degree, non-HR" },
        { value: '13', label: 'MBA' },
        { value: '14', label: 'MBA, HR Concentration' },
        { value: '15', label: 'MBA, non-HR Concentration' },
        { value: '16', label: 'Some College' },
      ],
      // archived specialties: [
      //   { value: '1', label: 'Administrative Support' },
      //   { value: '2', label: 'Administrator' },
      //   { value: '3', label: 'Benefits' },
      //   { value: '4', label: 'Communications' },
      //   { value: '5', label: 'Compensation' },
      //   { value: '6', label: 'Consultant' },
      //   { value: '7', label: 'Consultant - Independent' },
      //   { value: '8', label: 'Consultant - Multi-person Firm' },
      //   { value: '9', label: 'Diversity' },
      //   { value: '10', label: 'EEO/Affirmative Action' },
      //   { value: '11', label: 'Employee Asst. Programs' },
      //   { value: '12', label: 'Employee Relations' },
      //   { value: '13', label: 'Employment/Recruitment' },
      //   { value: '14', label: 'Health, Safety, Security' },
      //   { value: '15', label: 'HR Generalist' },
      //   { value: '16', label: 'HRIS' },
      //   { value: '17', label: 'International HRM' },
      //   { value: '18', label: 'Labor/Industrial Relations' },
      //   { value: '19', label: 'Legal' },
      //   { value: '20', label: 'Manage Outsourced HR' },
      //   { value: '21', label: 'Organizational Development' },
      //   { value: '22', label: 'Other' },
      //   { value: '23', label: 'Relocation' },
      //   { value: '24', label: 'Research' },
      //   { value: '25', label: 'Strategic Planning' },
      //   { value: '26', label: 'Training/Development' },
      //   { value: '27', label: 'Academician' },
      //   { value: '28', label: 'Practitioner' },
      // ],
      directReportsNumbers: [
        { value: '1', label: '0' },
        { value: '2', label: '1' },
        { value: '3', label: '2-4' },
        { value: '4', label: '5-9' },
        { value: '5', label: '10-24' },
        { value: '6', label: '25-49' },
        { value: '7', label: '50-99' },
        { value: '8', label: '100-499' },
        { value: '9', label: '500 or more' },
      ],
      gcrGenderSexList: [
        { value: '1', label: 'Male' },
        { value: '2', label: 'Female' },
        { value: '3', label: 'Prefer not to answer' },
      ],
      gcrEthnicityRaceList: [
        {
          value: '1',
          label: 'White',
        },
        {
          value: '2',
          label: 'Black or African American',
        },
        {
          value: '3',
          label: 'Hispanic or Latino',
        },
        {
          value: '4',
          label: 'Asian',
        },
        {
          value: '5',
          label: 'American Indian or Alaska Native',
        },
        {
          value: '6',
          label: 'Middle Eastern or North African',
        },
        {
          value: '7',
          label: 'Native Hawaiian or Pacific Islander',
        },
        {
          value: '8',
          label: 'Prefer not to answer',
        },
      ],
      gcrStudentList: [
        { value: '1', label: 'Yes, full time student' },
        { value: '2', label: 'Yes, part-time student' },
        { value: '3', label: 'No, I am not a student' },
      ],
      gcrIndustryList: [
        { value: '1', label: 'Agriculture, Forestry, Fishing and Hunting' },
        { value: '2', label: 'Mining, Quarrying, and Oil and Gas Extraction' },
        { value: '3', label: 'Utilities' },
        { value: '4', label: 'Construction' },
        { value: '5', label: 'Manufacturing' },
        { value: '6', label: 'Wholesale Trade' },
        { value: '7', label: 'Retail Trade' },
        { value: '8', label: 'Transportation and Warehousing' },
        { value: '9', label: 'Information' },
        { value: '10', label: 'Finance and Insurance' },
        { value: '11', label: 'Real Estate and Rental and Leasing' },
        { value: '12', label: 'Professional, Scientific, and Technical Services' },
        { value: '13', label: 'Management of Companies and Enterprises' },
        {
          value: '14',
          label: 'Administrative and Support and Waste Management and Remediation Services',
        },
        { value: '15', label: 'Educational Services' },
        { value: '16', label: 'Health Care and Social Assistance' },
        { value: '17', label: 'Arts, Entertainment, and Recreation' },
        { value: '18', label: 'Accommodation and Food Services' },
        { value: '19', label: 'Other Services (except Public Administration)' },
        { value: '20', label: 'Public Administration' },
      ],
      gcrCompanySizeList: [
        { value: '1', label: '1' },
        { value: '2', label: '2-24' },
        { value: '3', label: '25-49' },
        { value: '4', label: '50-99' },
        { value: '5', label: '100-249' },
        { value: '6', label: '250-499' },
        { value: '7', label: '500-999' },
        { value: '8', label: '1,000-2,499' },
        { value: '9', label: '2,500-4,999' },
        { value: '10', label: '5,000-9,999' },
        { value: '11', label: '10,000-24,999' },
        { value: '12', label: '25,000 and over' },
      ],
      gcrJobFunctionList: [
        { value: '1', label: 'C-Suite and Board Relations' },
        { value: '2', label: 'Employee Experience' },
        { value: '3', label: 'ESG, Ethics & Compliance' },
        { value: '4', label: 'Future of Work' },
        { value: '5', label: 'HR Consulting' },
        { value: '6', label: 'HR Function Strategy & Management' },
        { value: '7', label: 'HR Technology' },
        { value: '8', label: 'Inclusion & Diversity (I&D)' },
        { value: '9', label: 'Labor & Employee Relations' },
        { value: '10', label: 'Leadership & Manager Development' },
        { value: '11', label: 'Learning & Development' },
        { value: '12', label: 'Organization Design & Change Management' },
        { value: '13', label: 'Performance Management' },
        { value: '14', label: 'Recruiting' },
        { value: '15', label: 'Talent Analytics' },
        { value: '16', label: 'Talent Management' },
        { value: '17', label: 'Total Rewards' },
        { value: '18', label: 'Other HR function' },
        { value: '19', label: 'Other Non-HR function' },
      ],
      gcrJobLevelList: [
        { value: '1', label: 'Individual Contributor' },
        { value: '2', label: 'Manager, Supervisor' },
        { value: '3', label: 'Director' },
        { value: '4', label: 'VP' },
        { value: '5', label: 'CHRO' },
        { value: '6', label: 'C-Suite (other than CHRO or CEO)' },
        { value: '7', label: 'CEO, President' },
        { value: '8', label: 'Other (retired, unemployed)' },
      ],
      gcrContentFormatPreferenceList: [
        {
          value: '1',
          label: 'Podcast',
        },
        {
          value: '2',
          label: 'Video',
        },
        {
          value: '3',
          label: 'Text-Based',
        },
        {
          value: '4',
          label: 'Image-based',
        },
        {
          value: '5',
          label: 'Multimedia',
        },
      ],
      gcrContentChannelPreferenceList: [
        {
          value: '1',
          label: 'Website',
        },
        {
          value: '2',
          label: 'Mobile App',
        },
        {
          value: '3',
          label: 'Social Media',
        },
        {
          value: '4',
          label: 'Audio Streaming Service',
        },
        {
          value: '5',
          label: 'Video Streaming Service',
        },
        {
          value: '6',
          label: 'SMS',
        },
        {
          value: '7',
          label: 'eMail',
        },
      ],
      birthDays: [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10' },
        { value: '11', label: '11' },
        { value: '12', label: '12' },
        { value: '13', label: '13' },
        { value: '14', label: '14' },
        { value: '15', label: '15' },
        { value: '16', label: '16' },
        { value: '17', label: '17' },
        { value: '18', label: '18' },
        { value: '19', label: '19' },
        { value: '20', label: '20' },
        { value: '21', label: '21' },
        { value: '22', label: '22' },
        { value: '23', label: '23' },
        { value: '24', label: '24' },
        { value: '25', label: '25' },
        { value: '26', label: '26' },
        { value: '27', label: '27' },
        { value: '28', label: '28' },
        { value: '29', label: '29' },
        { value: '30', label: '30' },
        { value: '31', label: '31' },
      ],
      birthMonths: [
        { value: '1', label: 'January' },
        { value: '2', label: 'February' },
        { value: '3', label: 'March' },
        { value: '4', label: 'April' },
        { value: '5', label: 'May' },
        { value: '6', label: 'June' },
        { value: '7', label: 'July' },
        { value: '8', label: 'August' },
        { value: '9', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' },
      ],
      birthYearsLowerLimit: 1920,
      birthYearsUpperLimit: 2004,
      // ethnicities: [
      //   { value: '1', label: 'American Indian/Alaskan Native' },
      //   { value: '2', label: 'Asian' },
      //   { value: '3', label: 'Asian/Pacific-Islander' },
      //   { value: '4', label: 'Black/African American' },
      //   { value: '5', label: 'Hispanic' },
      //   { value: '6', label: 'Hispanic/Other Latino' },
      //   { value: '7', label: 'Hispanic/White Latino' },
      //   { value: '8', label: 'Multicultural/Other' },
      //   { value: '9', label: 'Native Hawaiian/Pacific Islander' },
      //   { value: '10', label: 'Undisclosed' },
      //   { value: '11', label: 'White' },
      //   { value: '12', label: 'Other' },
      // ],
      primaryLanguages: [
        { value: '1', label: 'Afrikaans' },
        { value: '2', label: 'Arabic' },
        { value: '3', label: 'Braille' },
        { value: '4', label: 'Bulgarian' },
        { value: '5', label: 'Cantonese' },
        { value: '6', label: 'Chinese - Cantonese' },
        { value: '7', label: 'Chinese - Mandarin' },
        { value: '8', label: 'Croatian' },
        { value: '9', label: 'Czech' },
        { value: '10', label: 'Danish' },
        { value: '11', label: 'Egyptian' },
        { value: '12', label: 'English' },
        { value: '13', label: 'Finnish' },
        { value: '14', label: 'French' },
        { value: '15', label: 'German' },
        { value: '16', label: 'Greek' },
        { value: '17', label: 'Hebrew' },
        { value: '18', label: 'Hindustani / Hindi' },
        { value: '19', label: 'Hungarian' },
        { value: '20', label: 'Icelandic' },
        { value: '21', label: 'Indonesian' },
        { value: '22', label: 'Italian' },
        { value: '23', label: 'Japanese' },
        { value: '24', label: 'Korean' },
        { value: '25', label: 'Norwegian' },
        { value: '26', label: 'Polish' },
        { value: '27', label: 'Portuguese' },
        { value: '28', label: 'Punjabi' },
        { value: '29', label: 'Romanian' },
        { value: '30', label: 'Russian' },
        { value: '31', label: 'Serbian' },
        { value: '32', label: 'Sign Language (all forms)' },
        { value: '33', label: 'Spanish' },
        { value: '34', label: 'Sudanese' },
        { value: '35', label: 'Swedish' },
        { value: '36', label: 'Thai' },
        { value: '37', label: 'Turkish' },
        { value: '38', label: 'Ukrainian' },
        { value: '39', label: 'Viennese' },
        { value: '40', label: 'Vietnamese' },
        { value: '41', label: 'Welsh' },
        { value: '42', label: 'Other' },
      ],
      companySizes: [
        { value: '1', label: '1-24' },
        { value: '2', label: '25-49' },
        { value: '3', label: '50-99' },
        { value: '4', label: '100-249' },
        { value: '5', label: '250-499' },
        { value: '6', label: '500-999' },
        { value: '7', label: '1000-2499' },
        { value: '8', label: '2500-4999' },
        { value: '9', label: '5000-9999' },
        { value: '10', label: '10000-24999' },
        { value: '11', label: '25000 and over' },
      ],
      // hrDeptSizes: [
      //   { value: '1', label: '0-1' },
      //   { value: '2', label: '2-4' },
      //   { value: '3', label: '5-9' },
      //   { value: '4', label: '10-24' },
      //   { value: '5', label: '25-49' },
      //   { value: '6', label: '50-99' },
      //   { value: '7', label: '100 and over' },
      // ],
      // industryCodes: [
      //   { value: '4', label: 'Admin, Waste Mgmt., Remediation Svcs' },
      //   { value: '5', label: 'Aerospace & Defense' },
      //   { value: '6', label: 'Arts, Entertainment, Recreation' },
      //   { value: '7', label: 'Association – Professional/Trade' },
      //   { value: '8', label: 'Automotive & Transport' },
      //   { value: '9', label: 'Biotech' },
      //   { value: '10', label: 'Construction, Mining, Gas & Oil' },
      //   { value: '11', label: 'Consulting' },
      //   { value: '12', label: 'Education' },
      //   { value: '13', label: 'Finance' },
      //   { value: '14', label: 'Food' },
      //   { value: '15', label: 'Government' },
      //   { value: '16', label: 'Health Care' },
      //   { value: '17', label: 'Industrial Manufacturing' },
      //   { value: '18', label: 'Insurance' },
      //   { value: '19', label: 'Manufacturing' },
      //   { value: '20', label: 'Media' },
      //   { value: '21', label: 'Membership Organizations' },
      //   { value: '22', label: 'Mgmt Companies, Enterprises' },
      //   { value: '23', label: 'Nonprofit' },
      //   { value: '24', label: 'Other' },
      //   { value: '25', label: 'Outsourcing' },
      //   { value: '26', label: 'Pharmaceuticals' },
      //   { value: '27', label: 'Publishing, Broadcasting, Other Media' },
      //   { value: '28', label: 'Real Estate' },
      //   { value: '29', label: 'Retail' },
      //   { value: '30', label: 'Services' },
      //   { value: '31', label: 'Technology' },
      //   { value: '32', label: 'Telecommunications' },
      //   { value: '33', label: 'Telecommunications equip/services' },
      //   { value: '34', label: 'Transportation Services' },
      //   { value: '35', label: 'Utilities, Energy' },
      // ],
      unitLevels: [
        { value: '1', label: 'Corporate' },
        { value: '2', label: 'Division' },
        { value: '3', label: 'Group' },
        { value: '4', label: 'Other' },
        { value: '5', label: 'Plant' },
        { value: '6', label: 'Region' },
        { value: '7', label: 'Subsidiary' },
      ],
      organizationTypes: [
        { value: '1', label: 'Govt Sector - Federal' },
        { value: '2', label: 'Govt Sector - State/Local' },
        { value: '3', label: 'Non-Profit' },
        { value: '4', label: 'Privately Owned For-Profit' },
        { value: '5', label: 'Publicly Traded For-Profit' },
        { value: '6', label: 'Other' },
      ],
      supervisorPositions: [
        { value: '1', label: 'Administrator' },
        { value: '2', label: 'CFO' },
        { value: '3', label: 'Chief of Staff, Div Head, Dept Chair' },
        { value: '4', label: 'CHRO, CHCO' },
        { value: '5', label: 'COO' },
        { value: '6', label: 'Dean, Superintendent, General Manager' },
        { value: '7', label: 'Director of HR' },
        { value: '8', label: 'Exec Officer (Govt/Military)' },
        { value: '9', label: 'HR Manager' },
        { value: '10', label: "I'm Highest Ranked In My Org" },
        { value: '11', label: 'Other' },
        { value: '12', label: 'Partner, Principal, Executive Director' },
        { value: '13', label: 'President, CEO, Chairman' },
        { value: '14', label: 'SVP of HR or other SVP' },
        { value: '15', label: 'VP Finance, Controller' },
        { value: '16', label: 'VP of HR' },
      ],
      purchasingDecisions: [
        { value: '1', label: 'Make the final Decision' },
        { value: '2', label: 'None, I am not involved in purchasing decision' },
        { value: '3', label: 'Recommended Solutions' },
      ],
      academicMajors: [
        { value: '1', label: 'Business Administration & Management' },
        { value: '2', label: 'HR Development' },
        { value: '3', label: 'HR Management' },
        { value: '4', label: 'Industrial/Organizational Psychology' },
        { value: '5', label: 'Labor Relations' },
        { value: '6', label: 'MBA' },
        { value: '7', label: 'MBA/HR' },
        { value: '8', label: 'Organizational Behavior/Development' },
        { value: '9', label: 'Other' },
        { value: '10', label: 'Sociology' },
      ],
      employmentStatuses: [
        { value: '1', label: "Don't list online" },
        { value: '2', label: 'Enlisted' },
        { value: '3', label: 'Exempt' },
        { value: '4', label: 'Non-Exempt' },
        { value: '5', label: 'Officer' },
        { value: '6', label: 'Unemployed' },
        { value: '7', label: 'Retired' },
      ],
      enrollmentStatuses: [
        { value: '1', label: 'Masters' },
        { value: '2', label: 'PHD' },
        { value: '3', label: 'Bachelors' },
        { value: '4', label: 'Associates' },
      ],
      universityStates: [
        { value: '1', label: 'AK' },
        { value: '2', label: 'AL' },
        { value: '3', label: 'AR' },
        { value: '4', label: 'AS' },
        { value: '5', label: 'AZ' },
        { value: '6', label: 'CA' },
        { value: '7', label: 'CO' },
        { value: '8', label: 'CT' },
        { value: '9', label: 'DC' },
        { value: '10', label: 'DE' },
        { value: '11', label: 'FL' },
        { value: '12', label: 'GA' },
        { value: '13', label: 'GU' },
        { value: '14', label: 'HI' },
        { value: '15', label: 'IA' },
        { value: '16', label: 'ID' },
        { value: '17', label: 'IL' },
        { value: '18', label: 'IN' },
        { value: '19', label: 'KS' },
        { value: '20', label: 'KY' },
        { value: '21', label: 'LA' },
        { value: '22', label: 'MA' },
        { value: '23', label: 'MD' },
        { value: '24', label: 'ME' },
        { value: '25', label: 'MI' },
        { value: '26', label: 'MN' },
        { value: '27', label: 'MO' },
        { value: '28', label: 'MP' },
        { value: '29', label: 'MS' },
        { value: '30', label: 'MT' },
        { value: '31', label: 'NC' },
        { value: '32', label: 'ND' },
        { value: '33', label: 'NE' },
        { value: '34', label: 'NH' },
        { value: '35', label: 'NJ' },
        { value: '36', label: 'NM' },
        { value: '37', label: 'NV' },
        { value: '38', label: 'NY' },
        { value: '39', label: 'OH' },
        { value: '40', label: 'OK' },
        { value: '41', label: 'OR' },
        { value: '42', label: 'PA' },
        { value: '43', label: 'PR' },
        { value: '44', label: 'PW' },
        { value: '45', label: 'RI' },
        { value: '46', label: 'SC' },
        { value: '47', label: 'SD' },
        { value: '48', label: 'TN' },
        { value: '49', label: 'TX' },
        { value: '50', label: 'UT' },
        { value: '51', label: 'VA' },
        { value: '52', label: 'VI' },
        { value: '53', label: 'VT' },
        { value: '54', label: 'WA' },
        { value: '55', label: 'WI' },
        { value: '56', label: 'WV' },
        { value: '57', label: 'WY' },
        { value: '58', label: 'ZF' },
        { value: '59', label: 'ZY' },
        { value: '60', label: 'ZZ' },
      ],
      creditTerms: [
        { value: '1', label: 'Compressed' },
        { value: '2', label: 'Quarter' },
        { value: '3', label: 'Semester' },
      ],
      hrInterests: [
        { value: '1', label: 'Benefits' },
        { value: '2', label: 'Business Education' },
        { value: '3', label: 'California Law' },
        { value: '4', label: 'Communications' },
        { value: '5', label: 'Awards and Incentives' },
        { value: '6', label: 'Compensation' },
        { value: '7', label: 'Corporate Ethics' },
        { value: '8', label: 'Diversity, EEO, Affirmative Action' },
        { value: '9', label: 'Employee Assistance Programs' },
        { value: '10', label: 'Employee Relations' },
        { value: '11', label: 'Health and Wellness' },
        { value: '12', label: 'Health, Safety, Security' },
        { value: '13', label: 'HR Consulting' },
        { value: '14', label: 'HRIS, Technology' },
        { value: '15', label: 'Immigration' },
        { value: '16', label: 'International HRM, Multinational HR Ops' },
        { value: '17', label: 'Labor, Industrial Relations' },
        { value: '18', label: 'Measurement, Metrics' },
        { value: '19', label: 'Organizational Development' },
        { value: '20', label: 'Outsourcing, Offshoring' },
        { value: '21', label: 'Relocation' },
        { value: '22', label: 'Staffing, Recruitment, Retention' },
        { value: '23', label: 'Strategic Planning' },
        { value: '24', label: 'Training & Development' },
        { value: '25', label: 'Workforce Law, Compliance' },
        { value: '26', label: 'Workplace Planning, Readiness' },
        { value: '27', label: 'Other' },
      ],
      gcrJobFunction: [],
    };

    const profile: IProfile = {
      dnbToken: '6l5aXo2O9c1fF11S7X5c9D41q421',
      uniqueId: '00000000-0000-0000-0000-000000000000',
      masterCustomerId: 'E3D22DA6-FAE2-E511-80DB-00505688482B',
      membershipType: 'Professional',
      prefix: '',
      firstName: 'Glenn',
      middleName: '',
      lastName: 'Hickman',
      nickName: '',
      suffix: '',
      credentialsAndCertification: [],
      shouldRefreshUser: false,
      yearStartedHR: '1967',
      educationLevel: '13',

      // archived
      // specialtyCode: '16',
      // specialtyOther: '',
      directReportsNumber: '6',
      // gender: '3',
      gcrGenderSex: '3',
      // secondaryEmail: '',
      birthDay: '11',
      birthMonth: '01',
      birthYear: '1981',
      birthDate: '',
      // ethnicity: '9',
      primaryLanguage: '13',
      companyName: 'Society for Human Resource Management (SHRM)',
      companyDnbNumber: '962332891',
      companySelected: 'Society for Human Resource Management (SHRM)',
      jobTitle: 'Senior Software Engineerer',
      companySize: '3',
      hrDepartmentSize: '2',
      unitLevel: '',
      // industryType: '5',
      organizationType: '',
      isOrganizationInternational: false,
      supervisorsTitle: '3',
      purchasingDecision: '',
      isOrganizationUnionized: false,
      academicMajor: '',
      universityState: '',
      university: '',
      universityDnbNumber: '0',
      universityUnitId: '0',
      universitySelected: '',
      employmentStatus: '',
      graduationDate: '',
      enrollmentStatus: '',
      numberCredits: '',
      creditTerm: '',
      chapterId: '',
      chapterState: '',
      chapterWebAddress: '',
      chapterName: '',
      isChapterDualBilling: false,
      chapters: null,
      isDualChapterMembershipEnabled: false,
      myHRInterests: ['3'],
      salaryCreditBalance: null,
      exemptionStatus: 'True',
      gcrEthnicityRace: '2',
      gcrStudent: '',
      gcrIndustry: '',
      gcrCompanySize: '',
      gcrJobFunctionPrimary: '',
      gcrJobLevel: '',
      altEmail: '',
      gcrHrInterest: ['0'],
      gcrContentFormatPreference: ['3'],
      gcrContentChannelPreference: ['1'],
      gcrJobFunctionSecondary: ['0'],
      gcrJobFunctionOthers: '',
    };

    const profileContainer: IProfileContainer = {
      profileEditModel: profileEdit,
      profileModel: profile,
    };

    return new Promise((resolve, reject) => {
      resolve({
        data: profileContainer,
      });
      throw new Error('Mock exception!');
    });
  }

  function getProfilePhoto(id: string) {
    const profilePhoto: IProfilePhoto = {
      addedBy: 'e3d22da6-fae2-e511-80db-00505688482b',
      addedDate: '2019-10-08T11:39:43.18',
      base64Image: '',
      imageName: '',
      photoLink:
        'https://shrm-res.cloudinary.com/image/upload/v1614961087/crnw6mm2pfiyzzktvkdw.jpg',
      profilePhotoId: 124899,
      ssouuId: 'e3d22da6-fae2-e511-80db-00505688482b',
      updatedBy: 'e3d22da6-fae2-e511-80db-00505688482b',
      updatedDate: '2021-03-05T16:18:07.997',
    };

    return new Promise((resolve, reject) => {
      resolve({
        data: profilePhoto,
      });
      throw new Error('Mock exception!');
    });
  }

  function deleteProfilePhoto(id: number) {
    return new Promise((resolve, reject) => {
      resolve({
        data: '',
      });
      throw new Error('Mock exception!');
    });
  }

  function uploadProfilePhoto(profilePhoto: IProfilePhoto) {
    return new Promise((resolve, reject) => {
      resolve({
        data: '',
      });
      throw new Error('Mock exception!');
    });
  }

  function saveProfilePhoto(profilePhoto: IProfilePhoto) {
    return new Promise((resolve, reject) => {
      resolve({
        data: '',
      });
      throw new Error('Mock exception!');
    });
  }

  function getChaptersForState(id: string, stateCode: string, membershipType: string): any {
    const chapters: IChapterBilling[] = [
      { label: 'Baldwin County SHRM', value: '356508', isDualBilling: false },
      { label: 'Birmingham SHRM', value: '356517', isDualBilling: false },
      { label: 'Calhoun County SHRM', value: '356533', isDualBilling: false },
      { label: 'Cullman Area-SHRM', value: '356581', isDualBilling: false },
      { label: 'East Alabama SHRM', value: '356596', isDualBilling: false },
      { label: 'Escambia County SHRM', value: '356606', isDualBilling: false },
      { label: 'Marshall County HR Mgmt. Assn.', value: '356755', isDualBilling: false },
      { label: 'Mobile SHRM', value: '356777', isDualBilling: false },
      { label: 'North Alabama Chapter of SHRM', value: '356791', isDualBilling: false },
      { label: 'Shoals Chapter - SHRM', value: '356884', isDualBilling: true },
      { label: 'SHRM-Montgomery', value: '356922', isDualBilling: false },
      { label: 'Tennessee Valley Chapter of SHRM', value: '356991', isDualBilling: false },
      { label: 'Tuscaloosa HR Professionals', value: '357009', isDualBilling: false },
      { label: 'Wiregrass Human Resource Mgmt. Assn.', value: '357042', isDualBilling: false },
    ];

    return new Promise((resolve, reject) => {
      resolve({
        data: chapters,
      });
      throw new Error('Mock exception!');
    });
  }

  function updateProfile(id: string, data: IProfile): any {
    return new Promise((resolve, reject) => {
      resolve({
        data: 'success',
      });
      throw new Error('Mock exception!');
    });
  }

  function getDnbName(dnbToken: string, searchTerm: string) {
    return new Promise((resolve, reject) => {
      resolve({
        data: 'success',
      });
      throw new Error('Mock exception!');
    });
  }

  function getCollegeName(searchTerm: string) {
    return new Promise((resolve, reject) => {
      resolve({
        data: 'success',
      });
      throw new Error('Mock exception!');
    });
  }

  return {
    getProfile,
    getProfilePhoto,
    getChaptersForState,
    updateProfile,
    deleteProfilePhoto,
    uploadProfilePhoto,
    saveProfilePhoto,
    getDnbName,
    getCollegeName,
  };
}

export default profileServiceMock;
